<template>
  <div class="main" :style="{ overflow: overflow }">
    <!--<div class="background-image"></div>-->
    <HeaderItem />
    <!--<CardSection />-->
    <!--<TextSection 
      :headerText="$t('text.salen')" 
      :text="$t('text.salen_info_text')"
    />-->
    <!--<FamilyInfoSection v-if="isFamily" />-->
    <!--<ContactComponent/>-->
  </div>
</template>

<script>
import HeaderItem from "../sections/HeaderItem.vue";
//import CardSection from "../sections/CardSection.vue";
//import TextSection from "../sections/TextSection.vue";
//import FamilyInfoSection from "../sections/FamilyInfoSection.vue";
//import ContactComponent from "../components/ContactComponent.vue";

export default {
  name: "HomePage",
  components: {
    HeaderItem,
    /*TextSection,
    FamilyInfoSection,
    CardSection,
    ContactComponent*/
  },
  data() {
    return {
      overflow: "visible"
    };
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
    user() {
      return this.$store.state.user != null
        ? this.$store.getters.user
        : { first_name: "Okänd" };
    },
    status() {
      return this.$store.getters.authStatus;
    },
    token_issued_at() {
      return this.$store.getters.token_issued_at;
    },
    token() {
      return this.$store.getters.token;
    },
    token_valid() {
      return this.$store.getters.token_valid;
    },
    isLoggedIn() {
      return (
        this.$store.getters.token_valid &&
        this.$store.getters.isLoggedIn
        );
    },
    isFamily() {
      return (
        this.isLoggedIn &&
        this.$store.getters.user.clearance > 0
      );
    },
  },
  methods: {
    handleScroll(event) {
      event.preventDefault();
      let sectionY = window.innerHeight / 2;
      let currentY = window.scrollY;
      if (currentY > sectionY - 5 && currentY < sectionY + 5) {
        //this.overflow = "hidden";
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.main {
  height: 100%;
}
.info-container {
  text-align: left;
  max-width: 800px;
  margin:auto;
  color: #eee;
  padding:16px;
  margin-top:40px;
}
</style>
